<template>
  <div class="g-content home-content">
    <!-- 第一行 -->
    <div
      class="home-row home-row1"
      v-auth="['auth_home_siteStat', 'auth_home_device_fault_history']"
    >
      <!-- 站点饼 -->
      <div class="home-block home-site" v-auth="['auth_home_siteStat']">
        <div class="home-block-title">
          <h2>{{ $t('site_title') }}</h2>
          <div class="home-block-select">
            <a-select
              :getPopupContainer="triggerNode => triggerNode.parentNode"
              v-model="stationCustomerId"
              show-search
              placeholder="Select a customer"
              :allowClear="stationCustomerId !== 0"
              @change="stationCustomerChange"
              :filter-option="
                (input, option) => {
                  return (
                    option.componentOptions.children[0].text
                      .toLowerCase()
                      .indexOf(input.toLowerCase()) >= 0
                  );
                }
              "
            >
              <a-select-option :value="0">
                {{ $t('customer_form_all_customer') }}
              </a-select-option>
              <a-select-option
                v-for="customer in customerList"
                :key="customer.customerId"
                :value="customer.customerId"
              >
                {{ customer.name }}
              </a-select-option>
            </a-select>
          </div>
        </div>
        <div class="home-block-content">
          <Loading :show="true" type="icon" v-if="stationStatLoading" />
          <div class="home-block-chart">
            <!-- 站点统计 -->
            <Pie
              :totalText="$t('home_pie_total')"
              :total="stationStat.total || 0"
              :dataSource="stationStat.list"
              :empty="!stationStat || (stationStat && stationStat.total === 0)"
              :colorList="pieColors"
            />
          </div>
          <div class="home-block-right">
            <div class="home-block-item">
              <p>{{ $t('home_pie_legend_enable') }}</p>
              <p>
                <strong>{{ stationStat.data.enableNum }}</strong
                ><span>{{ $t('home_site_units') }}</span>
              </p>
            </div>
            <div class="home-block-item">
              <p>{{ $t('home_pie_legend_disable') }}</p>
              <p>
                <strong> {{ stationStat.data.disableNum }} </strong
                ><span>{{ $t('home_site_units') }}</span>
              </p>
            </div>
            <ul class="home-block-item home-block-legend">
              <!-- 图例 -->
              <ul class="home-block-item home-block-legend">
                <li v-for="(item, index) in stationStat.list" :key="index">
                  <i
                    class="home-block-color"
                    :style="`background:${pieColors[index] || pieColorsDefault[index]}`"
                  >
                  </i
                  ><span>{{ item.item }}</span>
                </li>
              </ul>
            </ul>
          </div>
        </div>
      </div>

      <div
        class="home-block home-failure-log"
        v-if="authList.includes('auth_home_device_fault_history')"
      >
        <!-- 故障统计 -->
        <FailureStatistics :customerList="customerList" />
      </div>
    </div>

    <!-- 第二行 -->
    <div
      class="home-row home-row2"
      v-auth="[
        'auth_home_deviceCount',
        'auth_home_deviceModel',
        'auth_home_alarm',
        'auth_home_device_fault_ranking',
      ]"
    >
      <!-- 设备饼图 -->
      <div
        class="home-block home-device"
        v-auth="['auth_home_deviceCount', 'auth_home_deviceModel', 'auth_home_alarm']"
      >
        <div class="home-block-title">
          <h2>{{ $t('device_title') }}</h2>
          <div class="home-block-select">
            <a-select
              :getPopupContainer="triggerNode => triggerNode.parentNode"
              show-search
              v-model="deviceStatType"
              @change="deviceTypeChange"
              :filter-option="
                (input, option) => {
                  return (
                    option.componentOptions.children[0].text
                      .toLowerCase()
                      .indexOf(input.toLowerCase()) >= 0
                  );
                }
              "
            >
              <a-select-option :value="item.value" v-for="item in devicePieTypes" :key="item.value">
                {{ item.name }}
              </a-select-option>
            </a-select>

            <a-select
              :getPopupContainer="triggerNode => triggerNode.parentNode"
              v-model="deviceCustomerId"
              show-search
              :placeholder="$t('customer_form_select_placehoder')"
              :allowClear="deviceCustomerId !== 0"
              @change="deviceCustomerChange"
              v-if="deviceStatType !== 3"
              :filter-option="
                (input, option) => {
                  return (
                    option.componentOptions.children[0].text
                      .toLowerCase()
                      .indexOf(input.toLowerCase()) >= 0
                  );
                }
              "
            >
              <a-select-option :value="0">
                {{ $t('customer_form_all_customer') }}
              </a-select-option>
              <a-select-option
                v-for="customer in customerList"
                :key="customer.customerId"
                :value="customer.customerId"
              >
                {{ customer.name }}
              </a-select-option>
            </a-select>
          </div>
        </div>
        <div class="home-block-content">
          <Loading :show="deviceStatLoading" type="icon" v-if="deviceStatLoading" />
          <div class="home-block-chart">
            <!-- 告警统计 -->
            <Pie
              :totalText="$t('home_pie_device')"
              :total="alarmStat.total || 0"
              :dataSource="alarmStat.list"
              v-if="deviceStatType === 1"
              v-auth="['auth_home_alarm']"
              :empty="!alarmStat || (alarmStat && alarmStat.total === 0)"
              :colorList="pieColorsForDeviceAlarm"
              :height="280"
            />

            <!-- 设备数量统计 -->
            <Pie
              :totalText="$t('home_pie_device')"
              :total="deviceStat.total || 0"
              :dataSource="deviceStat.list"
              v-if="deviceStatType === 2"
              :empty="!deviceStat || (deviceStat && deviceStat.total === 0)"
              :colorList="pieColorsForDeviceStatus"
              :height="280"
            />

            <!-- 设备模型 -->
            <Pie
              :totalText="$t('home_pie_model')"
              :total="modelStat.total || 0"
              :dataSource="modelStat.list"
              v-if="deviceStatType === 3"
              :empty="!modelStat || (modelStat && modelStat.total === 0)"
              :height="280"
            />
          </div>

          <!-- 告警统计 -->
          <div class="home-block-right" v-if="deviceStatType === 1">
            <div class="home-block-item home-block-item2">
              <div>
                <p>{{ $t('home_pie_fault') }}</p>
                <p>
                  <strong>{{ alarmStat.data.faultNum }}</strong>
                </p>
              </div>
              <div>
                <p>{{ $t('home_pie_no_fault') }}</p>
                <p>
                  <strong>{{ alarmStat.data.noFaultNum }}</strong>
                </p>
              </div>
            </div>
            <div class="home-block-item home-block-item2">
              <div>
                <p>{{ $t('home_pie_part_fault') }}</p>
                <p>
                  <strong>{{ alarmStat.data.partFaultNum }}</strong>
                </p>
              </div>
              <div>
                <p>{{ $t('home_pie_alarm') }}</p>
                <p>
                  <strong>{{ alarmStat.data.alarmNum }}</strong>
                </p>
              </div>
            </div>
            <ul class="home-block-item home-block-legend">
              <!-- 错误 -->
              <li>
                <i class="home-block-color" :style="`background:${pieColorsForDeviceAlarm[0]};`"></i
                ><span>{{ $t('home_pie_fault') }}</span>
              </li>
              <!-- 没有报错 -->
              <li>
                <i class="home-block-color" :style="`background:${pieColorsForDeviceAlarm[1]};`"></i
                ><span>{{ $t('home_pie_no_fault') }}</span>
              </li>
              <!-- 部分报错 -->
              <li>
                <i class="home-block-color" :style="`background:${pieColorsForDeviceAlarm[2]};`"></i
                ><span>{{ $t('home_pie_part_fault') }}</span>
              </li>
              <!-- 告警 -->
              <li>
                <i class="home-block-color" :style="`background:${pieColorsForDeviceAlarm[3]}`"> </i
                ><span>{{ $t('home_pie_alarm') }}</span>
              </li>
            </ul>
          </div>

          <!-- 设备数量 -->
          <div class="home-block-right" v-if="deviceStatType === 2">
            <div class="home-block-item home-block-item2 home-block-item3">
              <!-- 空闲 -->
              <div>
                <p>{{ $t('home_pie_idle') }}</p>
                <p>
                  <strong>{{ deviceStat.data.idleNum }}</strong>
                </p>
              </div>
              <!-- 运行中 -->
              <div>
                <p>{{ $t('home_pie_working') }}</p>
                <p>
                  <strong>{{ deviceStat.data.workingNum }}</strong>
                </p>
              </div>
              <!-- 错误 -->
              <div>
                <p>{{ $t('home_pie_fault') }}</p>
                <p>
                  <strong>{{ deviceStat.data.faultNum }}</strong>
                </p>
              </div>
            </div>
            <div class="home-block-item home-block-item2 home-block-item3">
              <!-- 重启中 -->
              <div>
                <p>{{ $t('home_pie_restarting') }}</p>
                <p>
                  <strong>{{ deviceStat.data.restartingNum }}</strong>
                </p>
              </div>
              <!-- 更新中 -->
              <div>
                <p>{{ $t('home_pie_updating') }}</p>
                <p>
                  <strong>{{ deviceStat.data.updatingNum }}</strong>
                </p>
              </div>
            </div>

            <!-- 图例 -->
            <ul class="home-block-item home-block-legend">
              <li v-for="(item, index) in deviceStat.list" :key="index">
                <i
                  class="home-block-color"
                  :style="
                    `background:${pieColorsForDeviceStatus[index] || pieColorsDefault[index]}`
                  "
                >
                </i
                ><span>{{ item.item }}</span>
              </li>
            </ul>
          </div>

          <!-- 设备模型 -->
          <div class="home-block-right home-block-right2" v-if="deviceStatType === 3">
            <div class="home-block-item home-block-item4">
              <!-- 模型 -->
              <div v-for="(model, index) in modelStat.list" :key="index">
                <p>{{ model.item }}</p>
                <p>
                  <strong>{{ model.count + 1 }}</strong>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div
        class="home-block home-failure-log"
        v-if="authList.includes('auth_home_device_fault_ranking')"
      >
        <!-- 故障排行 -->
        <FailureRanking />
      </div>
    </div>

    <!-- 第三行 -->
    <div class="home-event-wrapper" v-if="hasDeviceEventRecentAuth || hasSiteEventRecentAuth">
      <div class="home-event-link">
        <router-link
          :to="{
            path: '/manage/system/logs/action/site',
          }"
          v-if="activekey === '1' && hasSiteActionLogAuth"
        >
          {{ $t('com_btn_more') }} <a-icon type="right" />
        </router-link>

        <router-link
          :to="{
            path: '/manage/system/logs/action/device-basic',
          }"
          v-if="activekey === '2' && hasDeviceActionLogAuth"
        >
          {{ $t('com_btn_more') }} <a-icon type="right" />
        </router-link>
      </div>
      <a-tabs
        :tabBarStyle="{ border: 'none' }"
        :activeKey="activekey"
        @change="tabChange"
        :animated="false"
      >
        <!-- 站点事件 -->
        <a-tab-pane key="1" :tab="$t('home_recent_site_event')" v-if="hasSiteEventRecentAuth">
          <div class="site-event">
            <a-table
              :columns="columns"
              :data-source="stationEvent"
              bordered
              rowKey="id"
              :loading="stationEventLoading"
              :pagination="false"
            >
            </a-table>
          </div>
        </a-tab-pane>
        <a-tab-pane
          key="2"
          :tab="$t('home_recent_device_event')"
          force-render
          v-if="hasDeviceEventRecentAuth"
        >
          <!-- 设备事件 -->
          <div class="device-event">
            <a-table
              :columns="columns"
              :data-source="deviceEvent"
              bordered
              rowKey="id"
              :loading="deviceEventLoading"
              :pagination="false"
            >
            </a-table>
          </div>
        </a-tab-pane>
      </a-tabs>
    </div>
  </div>
</template>

<script>
import Pie from '_c/charts/Pie';
import * as API from '@/api/home';
import * as CustomerAPI from '@/api/system/customer';
import { dragTableToScroll } from '@/libs/utils';
import { pieColorsDefault } from '@/config/colors';
import FailureStatistics from './components/FailureStatistics';
import FailureRanking from './components/FailureRanking';
import { hasApiMenuPermission } from '@/libs/permissions';
import { mapState } from 'vuex';

export default {
  components: {
    Pie,
    FailureStatistics,
    FailureRanking,
  },
  data() {
    return {
      hasApiMenuPermission,
      pieColorsDefault,
      filters: this.$options.filters,
      // 所属用户
      customerList: null,

      columns: [
        {
          title: this.$t('com_table_index'),
          align: 'center',
          width: 50,
          customRender: (text, record, index) => {
            return index + 1;
          },
        },
        {
          title: this.$t('logs_table_user'),
          align: 'center',
          dataIndex: 'executeUserName',
          width: 130,
        },

        {
          title: this.$t('logs_table_action_type'),
          align: 'center',
          dataIndex: 'updateType',
          customRender: text => {
            const typeObj = this.$t('com_operationTypes')[text];
            return typeObj ? typeObj.name : '--';
          },
          width: 100,
        },
        {
          title: this.$t('logs_table_location'),
          align: 'center',
          dataIndex: 'location',
          width: 130,
          customRender: text => {
            return this.filters.location(text);
          },
        },
        {
          title: this.$t('logs_table_ip'),
          align: 'center',
          dataIndex: 'hostIp',
          width: 100,
        },
        {
          title: this.$t('com_table_time'),
          align: 'center',
          dataIndex: 'executeTime',
          width: 160,
          customRender: text => {
            return this.filters.formatDate(text);
          },
        },
      ],

      // 站点
      stationStat: {
        total: 0,
        data: {},
        list: [],
      },
      stationStatLoading: false,

      stationEvent: [],

      stationEventLoading: false,
      stationCustomerId: 0,

      // 设备,0->所有
      deviceCustomerId: 0,
      deviceStatType: null,

      // 告警
      alarmStat: {
        total: 0,
        data: {},
        list: [],
      },

      // 设备
      deviceStat: {
        total: 0,
        data: {},
        list: [],
      },
      deviceStatLoading: false,

      deviceEvent: [],
      deviceColumns: [],
      deviceEventLoading: false,

      // 设备模型
      modelStat: [],

      // 设备图表类型列表
      devicePieTypes: [],

      horizontalScrollSite: null,
      horizontalScrollDevice: null,

      //饼图的颜色
      pieColors: ['#165DFF', '#50CD89', '#FF6B6B', '#FFC542'],
      // 报错，没有报错，部分报错,告警，
      pieColorsForDeviceAlarm: ['#FF6B6B', '#50CD89', '#165DFF', '#FFC542'],
      // 状态数量：空闲，运行中，错误，重启中，更新中
      pieColorsForDeviceStatus: ['#50CD89', '#165DFF', '#FF6B6B', '#FFC542', '#999'],

      // 当前活动Key
      activekey: '1',
    };
  },
  mounted() {
    // 告警统计
    if (hasApiMenuPermission('and', ['auth_home_alarm'])) {
      this.devicePieTypes.push({
        name: this.$t('home_pie_device_alarm'),
        value: 1,
      });
    }

    // 设备统计
    if (hasApiMenuPermission('and', ['auth_home_deviceCount'])) {
      this.devicePieTypes.push({
        name: this.$t('home_pie_device_count'),
        value: 2,
      });
    }

    // 设备模型统计
    if (hasApiMenuPermission('and', ['auth_home_deviceModel'])) {
      this.devicePieTypes.push({
        name: this.$t('home_pie_device_model'),
        value: 3,
      });
    }
    if (this.devicePieTypes && this.devicePieTypes.length) {
      this.deviceStatType = this.devicePieTypes[0].value;
      this.deviceTypeChange(this.deviceStatType);
    }

    // 默认event tabs
    if (this.hasSiteEventRecentAuth) {
      this.activekey = '1';
    } else {
      this.activekey = '2';
    }

    // 优先获取所属客户列表
    this.getCustomerList();
  },
  beforeDestroy() {
    this.horizontalScrollDestory();
  },
  computed: {
    ...mapState(['authList']),

    // 是否有站点操作日志权限
    hasSiteActionLogAuth() {
      return hasApiMenuPermission('and', ['auth_logs_action_site']);
    },

    // 是否有设备操作日志权限
    hasDeviceActionLogAuth() {
      return hasApiMenuPermission('and', ['auth_logs_action_device_event']);
    },

    // 有最近站点事件权限
    hasSiteEventRecentAuth() {
      return hasApiMenuPermission('and', ['auth_home_siteEvent']);
    },

    // 有最近设备事件权限
    hasDeviceEventRecentAuth() {
      return hasApiMenuPermission('and', ['auth_home_deviceEvent']);
    },
  },
  methods: {
    tabChange(activekey) {
      this.activekey = activekey;

      if (activekey === '1') {
        this.getStationEvent();
      } else if (activekey === '2') {
        this.getDeviceEvent();
      }
    },

    // 获取统计数据
    getData() {
      const _list = [];
      // 获取站点统计
      if (hasApiMenuPermission('and', ['auth_home_siteStat'])) {
        _list.push(this.getStationStat());
      }

      // 获取告警统计
      if (hasApiMenuPermission('and', ['auth_home_alarm'])) {
        _list.push(this.getAlarmStat());
      }

      // 获取站点事件
      if (hasApiMenuPermission('and', ['auth_home_siteEvent'])) {
        _list.push(this.getStationEvent());
      }

      // 设备事件
      if (hasApiMenuPermission('and', ['auth_home_deviceEvent'])) {
        _list.push(this.getDeviceEvent());
      }

      Promise.all(_list).finally(() => {
        // 全部接口返回时，清除loading
        this.$store.commit('setPageLoading', false);
        // 设置所有数据轮询
        // this.$store.commit('setPolling', this.getData);

        // 表格横向滚动注册
        this.$nextTick(() => {
          this.horizontalScrollDestory();
          this.horizontalScrollSite = dragTableToScroll(
            document.querySelector('.site-event .ant-table-body'),
            document.querySelector('.site-event .ant-table-body table')
          );

          this.horizontalScrollDevice = dragTableToScroll(
            document.querySelector('.device-event .ant-table-body'),
            document.querySelector('.device-event .ant-table-body table')
          );
        });
      });
    },

    // 横向滚动事件注销
    horizontalScrollDestory() {
      if (this.horizontalScrollSite) {
        this.horizontalScrollSite.destroy();
      }

      if (this.horizontalScrollDevice) {
        this.horizontalScrollDevice.destroy();
      }
    },

    // 获取该用户所有客户信息
    getCustomerList() {
      return CustomerAPI.CustomerList().then(res => {
        if (res && res.data) {
          this.customerList = res.data;

          // 获取统计数据(默认)
          this.getData();
        }
      });
    },

    // 获取站点统计
    getStationStat() {
      const params = {
        customerId: this.stationCustomerId,
      };
      return API.SiteStat(params)
        .then(res => {
          if (res && res.data) {
            const data = res.data;
            this.stationStat = {
              total: data.count,
              data,
              list: [
                {
                  item: this.$t('home_pie_site_disabled'),
                  count: data.disableNum,
                  percent: data.disableNum / data.count,
                },
                {
                  item: this.$t('home_pie_site_enabled'),
                  count: data.enableNum,
                  percent: data.enableNum / data.count,
                },
              ],
            };
          }
        })
        .finally(() => {
          this.stationStatLoading = false;
        });
    },

    // 获取站点事件
    getStationEvent() {
      const params = {
        customerId: this.stationCustomer,
      };
      this.stationEventLoading = true;
      return API.SiteEvent(params)
        .then(res => {
          if (res && res.data) {
            this.stationEvent = res.data;
          }
        })
        .finally(() => {
          this.stationEventLoading = false;
        });
    },

    // 获取设备事件
    getDeviceEvent() {
      const params = {
        customerId: this.stationCustomer,
      };
      this.deviceEventLoading = true;
      return API.DeviceEvent(params)
        .then(res => {
          if (res && res.data) {
            this.deviceEvent = res.data;
          }
        })
        .finally(() => {
          this.deviceEventLoading = false;
        });
    },

    // 获取告警统计
    getAlarmStat() {
      const params = {
        customerId: this.deviceCustomerId,
      };

      return API.AlarmStat(params)
        .then(res => {
          if (res && res.data) {
            const data = res.data;
            let totalCount = 0;
            Object.keys(data).forEach(key => {
              totalCount += data[key];
            });

            this.alarmStat = {
              total: totalCount,
              data,
              list: [
                // 报错
                {
                  item: this.$t('home_pie_fault'),
                  count: data.faultNum,
                  percent: data.faultNum / totalCount,
                },
                // 没有报错
                {
                  item: this.$t('home_pie_no_fault'),
                  count: data.noFaultNum,
                  percent: data.noFaultNum / totalCount,
                },
                // 部分报错
                {
                  item: this.$t('home_pie_part_fault'),
                  count: data.partFaultNum,
                  percent: data.partFaultNum / totalCount,
                },
                // 告警
                {
                  item: this.$t('home_pie_alarm'),
                  count: data.alarmNum,
                  percent: data.alarmNum / totalCount,
                },
              ],
            };
          }
        })
        .finally(() => {
          this.deviceStatLoading = false;
        });
    },

    // 获取设备数量统计
    getDeviceStat() {
      const params = {
        customerId: this.deviceCustomerId,
      };

      return API.DeviceStat(params)
        .then(res => {
          if (res && res.data) {
            const data = res.data;

            let totalCount = res.data.allNum;

            this.deviceStat = {
              total: totalCount,
              data,
              list: [
                // 空闲
                {
                  item: this.$t('home_pie_idle'),
                  count: data.idleNum,
                  percent: data.idleNum / totalCount,
                },
                // 运行中
                {
                  item: this.$t('home_pie_working'),
                  count: data.workingNum,
                  percent: data.workingNum / totalCount,
                },

                // 报错
                {
                  item: this.$t('home_pie_fault'),
                  count: data.faultNum,
                  percent: data.faultNum / totalCount,
                },

                // 重启中
                {
                  item: this.$t('home_pie_restarting'),
                  count: data.restartingNum,
                  percent: data.restartingNum / totalCount,
                },

                // 更新中
                {
                  item: this.$t('home_pie_updating'),
                  count: data.updatingNum,
                  percent: data.updatingNum / totalCount,
                },
              ],
            };
          }
        })
        .finally(() => {
          this.deviceStatLoading = false;
        });
    },

    // 获取设备模型统计
    getModelStat() {
      const params = {};

      return API.ModelStat(params)
        .then(res => {
          if (res && res.data) {
            const data = res.data;
            let totalCount = 0;

            // 总模型数量，包括父模型和子模型
            data.forEach(item => {
              totalCount += item.childCount + 1;
            });

            this.modelStat = {
              total: totalCount,
              list: [],
            };

            data.forEach(item => {
              this.modelStat.list.push({
                item: item.name,
                count: item.childCount,
                percent: item.childCount / totalCount,
              });
            });
          }
        })
        .finally(() => {
          this.deviceStatLoading = false;
        });
    },

    // 客户切换
    stationCustomerChange(value) {
      this.stationCustomerId = value || 0;

      this.stationStatLoading = true;
      this.getStationStat();
    },

    // 设备客户切换
    deviceCustomerChange(value) {
      this.deviceCustomerId = value || 0;
      this.deviceData();
    },

    // 设备图表切换
    deviceTypeChange(value) {
      this.deviceStatType = value;
      this.deviceData();
    },

    deviceData() {
      this.deviceStatLoading = true;
      if (this.deviceStatType === 1) {
        this.getAlarmStat();
      } else if (this.deviceStatType === 2) {
        this.getDeviceStat();
      } else if (this.deviceStatType === 3) {
        this.getModelStat();
      }
    },
  },
};
</script>

<style lang="less" scoped>
.home-content {
  width: 100%;
  background: @g-layout-background;

  .home-row {
    display: flex;
    justify-content: space-between;
    overflow: hidden;
    &.home-row1 {
      height: 368px;
      margin-bottom: 16px;
      gap: 16px;
    }
    &.home-row1 > div:only-child {
      flex: 0 0 100%;
    }

    &.home-row2 {
      min-height: 368px;
      gap: 16px;
    }

    &.home-row2 > div:only-child {
      flex: 0 0 100%;
    }

    .home-block {
      border-radius: 12px;
      background: #fff;
      padding: 24px;
      flex: 1 1 0%;

      // 站点
      &.home-site {
        flex: 0 1 40%;
        min-width: 400px;
      }

      // 设备
      &.home-device {
        flex: 0 1 40%;
      }

      // 标题
      .home-block-title {
        display: flex;
        justify-content: space-between;
        align-items: center;
        flex-wrap: wrap;

        h2 {
          color: #18181a;
          display: flex;
          align-items: center;
          margin: 0;
          font-size: 18px;
          font-weight: 600;
        }

        ::v-deep .home-block-select {
          display: flex;
          align-items: center;

          .ant-select {
            width: 170px;
            margin-left: 10px;
          }
        }
      }

      // 内容
      .home-block-content {
        display: flex;
        justify-content: space-between;
        height: 98%;
        position: relative;

        .home-block-chart {
          width: 50%;
          height: 100%;
          background: #fff;
          display: flex;
          align-items: center;
          justify-content: center;
        }

        .home-block-right {
          display: flex;
          flex-direction: column;
          justify-content: center;
          flex: 1;
          height: 100%;
          align-items: flex-start;
          padding-left: 20px;

          // 模型
          &.home-block-right2 {
            height: 295px;
            overflow-y: auto;
            justify-content: flex-start;
            margin-top: 20px;
          }

          .home-block-item {
            display: flex;
            align-items: flex-start;
            margin-bottom: 20px;
            flex-direction: column;
            justify-content: flex-start;
            width: 100%;

            // 一行排1个，超出则滚动
            .home-block-item1 {
              height: 40px;
              overflow-y: auto;
              > div {
                width: 100%;
              }
            }

            // 一行排两个
            &.home-block-item2 {
              flex-direction: row;
              white-space: nowrap;
              > div {
                width: 50%;
              }
            }

            // 一行排3个
            &.home-block-item3 {
              > div {
                width: 33%;
              }
            }

            &.home-block-legend {
              flex-direction: row;
              justify-content: flex-start;
              align-items: flex-start;
              white-space: nowrap;
              flex-wrap: wrap;

              li {
                display: flex;
                align-items: center;
                margin-bottom: 10px;
              }

              span {
                padding-right: 15px;
              }
            }

            p {
              margin: 0;
              color: #4e5969;
              font-size: 16px;
              font-weight: 400;
            }

            strong {
              color: #18181a;
              font-size: 32px;
              font-weight: 700;
            }

            span {
              color: #86909c;
              font-size: 12px;
              font-weight: 400;
            }

            .home-block-color {
              width: 12px;
              height: 12px;
              border-radius: 100%;
              display: inline-block;
              margin-right: 3px;
            }
          }
        }
      }

      // 故障统计
      &.home-failure-log {
        border-radius: 12px;
        flex: 1 0 60%;
        position: relative;
      }
    }
  }

  // 事件
  .home-event-wrapper {
    border-radius: 12px;
    background: #fff;
    margin-top: 16px;
    padding: 12px 24px;
    // height: 540px;
    position: relative;

    .home-event-link {
      position: absolute;
      top: 24px;
      right: 24px;
      cursor: pointer;
      color: @primary-color;
      z-index: 999;
    }

    ::v-deep .ant-tabs-nav {
      .ant-tabs-tab-active {
        &::before {
          position: absolute;
          top: auto;
          bottom: 0;
          left: 0;
          width: 100%;
          border: none;
          border-radius: 0.22917rem 0.22917rem 0 0;
          content: '';
          pointer-events: none;
          height: 3px;
          background: @primary-color;
        }
      }
    }
  }
}
</style>
